// src/slices/category/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// ================= GET ALL =================
export const getAllCategories = createAsyncThunk("category/getAll", async (categoryId, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/category`, { params: { categoryId } });
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data);
  }
});

// ================= GET BY ID =================
export const getCategoryById = createAsyncThunk("category/getById", async (id, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/category/one/${id}`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data);
  }
});

// ================= GET BY SLUG =================
export const getCategoryBySlug = createAsyncThunk("category/getBySlug", async (slug, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/category/one/slug/${slug}`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data);
  }
});
